var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16096",
    "data-name": "Group 16096",
    transform: "translate(-175 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6864",
    "data-name": "Rectangle 6864",
    width: 50,
    height: 50,
    transform: "translate(175 275)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-In",
    d: "M6.777,40a.638.638,0,0,1-.193-.024.989.989,0,0,1-.475-.219.648.648,0,0,1-.138-.139.858.858,0,0,1-.212-.393.808.808,0,0,1-.045-.3V25.714H8.007a3.428,3.428,0,0,0,5.68,2.347l6.264-5.481a3.43,3.43,0,0,0,0-5.161l-6.265-5.482a3.427,3.427,0,0,0-5.678,2.347H5.714V1.063A.844.844,0,0,1,5.771.75a.912.912,0,0,1,.25-.431A.7.7,0,0,1,6.178.194S6.19.181,6.212.168L6.233.157a.508.508,0,0,1,.213-.1A.63.63,0,0,1,6.577.019,1.1,1.1,0,0,1,6.777,0h28.5a1.064,1.064,0,0,1,1.063,1.063V38.938A1.064,1.064,0,0,1,35.276,40ZM13.285,2.132l13.93,3.587a.59.59,0,0,1,.443.569V33.25a.588.588,0,0,1-.431.569L12.77,37.868H34.208V2.131H13.285ZM22.24,18.194V21.35a.594.594,0,1,0,1.188,0V18.194a.594.594,0,1,0-1.188,0ZM10.286,25.8v-.269c0-.015,0-.03,0-.045V23.429H1a1,1,0,0,1-1-1V17.572a1,1,0,0,1,1-1h9.285V14.52c0-.015,0-.03,0-.045V14.2a1,1,0,0,1,1.659-.752l.231.2.006,0,.783.685,5.6,4.9a1,1,0,0,1,0,1.5l-.119.1,0,0-6.264,5.481-.007.006-.23.2a.98.98,0,0,1-.653.249A1,1,0,0,1,10.286,25.8Z",
    transform: "translate(182 280)",
    fill: "#0f5a9c",
    opacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/Check-In.e8e93e715e52ad32fc114ec85097cef9.svg";
export { ForwardRef as ReactComponent };